import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, CustomProvider } from 'firebase/app-check';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// ── App Check debug token must be set BEFORE initializeAppCheck ───────────
if (!environment.production &&
    (environment as any).appCheckDebugToken &&
    (environment as any).appCheckDebugToken !== 'REPLACE_WITH_DEBUG_TOKEN') {
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = (environment as any).appCheckDebugToken;
}

// ── Initialize Firebase + App Check synchronously before NgModule bootstrap ─
// AngularFireModule.initializeApp() will detect this existing app and reuse it.
const firebaseApp = initializeApp(environment.firebaseConfig);

initializeAppCheck(firebaseApp, {
  provider: environment.production && (environment as any).recaptchaSiteKey
    ? new ReCaptchaEnterpriseProvider((environment as any).recaptchaSiteKey)
    : new CustomProvider({
        getToken: () => Promise.reject(new Error('Dev: App Check debug token active')),
      }),
  isTokenAutoRefreshEnabled: true,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
